import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import PageTitle from "../../components/PageTitle/PageTitle";
import Widget from "../../components/Widget/Widget";
import SchoolFoodMenuService from "./Locality/Service/schoolFoodMenuService";
import { showAppConfirm } from '../../context/AlertContext';

const StyledTableCell = withStyles((theme) => ({
  head: { backgroundColor: "#0f3b62ad", color: theme.palette.common.white },
}))(TableCell);

const emptyForm = {
  foodItemName: "",
  status: "Active",
};

export default function SchoolFoodMenu() {
  const [menus, setMenus] = useState([]);
  const [open, setOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState(emptyForm);

  const userDetails = JSON.parse(localStorage.getItem("userDetail") || "{}");
  const schooleId = userDetails?.schooleId || "";

  const load = async () => {
    const menuItems = await SchoolFoodMenuService.listBySchool(schooleId, true);
    setMenus(menuItems || []);
  };

  useEffect(() => {
    if (!schooleId) return;
    load().catch(() => {});
  }, [schooleId]);

  const onSave = async () => {
    const body = {
      schooleId,
      foodItemName: String(form.foodItemName || "").trim(),
      status: form.status || "Active",
    };
    if (!body.foodItemName) return;

    if (editingId) await SchoolFoodMenuService.updateMenu(editingId, body);
    else await SchoolFoodMenuService.addMenu(body);

    setOpen(false);
    setEditingId(null);
    setForm(emptyForm);
    load();
  };

  const onEdit = (menu) => {
    setEditingId(menu._id);
    setForm({
      foodItemName: menu.foodItemName || "",
      status: menu.status || "Active",
    });
    setOpen(true);
  };

  const onDelete = async (menu) => {
    if (!await showAppConfirm("Delete this food menu period?")) return;
    await SchoolFoodMenuService.deleteMenu(menu._id);
    load();
  };

  return (
    <>
      <PageTitle
        title="School Food Menu"
        button={
          <Button
            variant="contained"
            color="secondary"
            style={{ backgroundColor: "rgb(15 59 98)" }}
            onClick={() => {
              setEditingId(null);
              setForm(emptyForm);
              setOpen(true);
            }}
          >
            Add Food Menu Item
          </Button>
        }
      />

      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget title="" upperTitle noBodyPadding>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell>Food Item Name</StyledTableCell>
                  <StyledTableCell>Status</StyledTableCell>
                  <StyledTableCell>Edit</StyledTableCell>
                  <StyledTableCell>Delete</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {menus.map((m) => (
                  <TableRow key={m._id}>
                    <TableCell>{m.foodItemName || "-"}</TableCell>
                    <TableCell>{m.status || "-"}</TableCell>
                    <TableCell>
                      <EditIcon style={{ cursor: "pointer" }} onClick={() => onEdit(m)} />
                    </TableCell>
                    <TableCell>
                      <DeleteIcon style={{ cursor: "pointer" }} onClick={() => onDelete(m)} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Widget>
        </Grid>
      </Grid>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{editingId ? "Edit Food Menu Item" : "Add Food Menu Item"}</DialogTitle>
        <DialogContent style={{ width: 420 }}>
          <TextField
            fullWidth
            margin="dense"
            label="Food Item Name"
            value={form.foodItemName}
            onChange={(e) => {
              const value = e?.target?.value || "";
              setForm((p) => ({ ...p, foodItemName: value }));
            }}
          />
          <TextField
            select
            fullWidth
            margin="dense"
            label="Status"
            value={form.status}
            onChange={(e) => {
              const value = e?.target?.value || "Active";
              setForm((p) => ({ ...p, status: value }));
            }}
          >
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Inactive">Inactive</MenuItem>
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button color="primary" variant="contained" onClick={onSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
